import { observable, action, decorate } from 'mobx';

import JobOfferService from 'services/JobOffer.service';
import LanguageService from 'services/Language.service';

class JobOffersStore {
  jobOffersPageContent = {};
  isContentFetched = observable.box(false);
  jobOffers = observable([]);
  initialFetchDone = observable.box(false);

  @action
  async fetchJobOffers() {
    if (this.isLoaded()) {
      return this.jobOffers;
    }

    try {
      const langCodesElevato = {
        pl: 'pl-PL',
        en: 'en-US'
      };
      const currentLangCode =
        langCodesElevato[LanguageService.getLang()] || 'en-US';
      const items = await JobOfferService.fetchElevatoJobOffers(
        100,
        true,
        currentLangCode,
        17
      );
      if (items && items.items && items.filter) {
        const logos = {};
        items.filter.clients.forEach(
          client => (logos[client.name.toLowerCase()] = client.description)
        );
        const itemsWithLogos = items.items.map(item => {
          item.logo = logos[item.client.toLowerCase()] || logos['tenderhut'];
          return item;
        });
        this.jobOffers.push(...itemsWithLogos);
      }
    } catch (e) {
      console.error('Failed to fetch job offers data', e);
    }

    this.initialFetchDone.set(true);
    return this.jobOffers;
  }

  filterJobOfferById(id) {
    return this.jobOffers.find(item => item.id === id);
  }

  @action
  async fetchPageContent() {
    if (this.isContentFetched.get()) {
      return this.jobOffersPageContent;
    }
    try {
      const items = await JobOfferService.fetchJobOffersPageContent();
      if (items.isEmpty) {
        return null;
      }

      this.jobOffersPageContent = items.items[0];
    } catch (e) {
      console.error('Failed to fetch job banner url data', e);
      return null;
    }
    this.isContentFetched.set(true);

    return this.jobOffersPageContent;
  }

  isLoaded() {
    return this.initialFetchDone.get();
  }
}

decorate(JobOffersStore, {
  jobOffersPageContent: observable
});

export default new JobOffersStore();



// WEBPACK FOOTER //
// ./src/stores/JobOffers.store.js